/**
 * @class {T.Form.CheckBox}
 * @extends {T.Form.Base}
 * @param {T.Form.CheckBox.Par|Object} par
 */
T.Form.CheckBox = Class(
	/**
	 * @lends {T.Form.CheckBox#}
	 */
	{
		__NAME: 'T.Form.CheckBox',

		_disabled: false,

		/**
		 * @param {T.Form.CheckBox.Par|Object} par
		 * @constructs
		 */
		__construct: function(par){
			this.par = par || {};

			this.node = mkE({
				tag: 'div',
				className: 'checkbox',
				els: [
					{
						tag: 'label',
						els: [
							{
								tag: 'div',
								className: 'checkbox-status',
								els: [
									this._itemNode = mkE({
										tag: 'input',
										className: 'form-control',
										type: par.type || 'checkbox',
										prop: {
											onchange: par.onChange || D.doNothing
										}
									}),
									{
										tag: 'div',
										className: 'checkbox-status-image',
										prop: {
											onclick: this._onClick
										}
									}
								]
							},
							this._captionNode = mkE({
								tag: 'div',
								className: 'checkbox-caption'
							})
						]
					},
					this._getErrorNode(),
					this._getHelpNode()
				]
			});

			if( par.small ){
				addClassName(this.node, 'checkbox-small');
			}

			this._par(par);
			this.value(par.checked || false);
			this.disabled(par.disabled || false);
		},

		value: function(v){
			if( isset(v) ){
				this._itemNode.checked = v;
			}
			return this._itemNode.checked;
		},

		disabled: function(v){
			if( v === true ){
				this._disabled = true;
				this._itemNode.disabled = true;
				addClassName(this.node, 'checkbox-disabled');
			}else{
				this._disabled = false;
				this._itemNode.disabled = false;
				removeClassName(this.node, 'checkbox-disabled');
			}
		},

		_onClick: function(e){
			if( this._disabled ){
				D.stopPropagation(e);
				return false;
			}
			if( this.par.onClick ){
				return this.par.onClick(e);
			}
		}
	},
	T.Form.Base
);

/**
 * @class {T.Form.CheckBox.Par}
 * @extends {T.Form.Base.Par}
 */
T.Form.CheckBox.Par = Class(
	/**
	 * @lends {T.Form.CheckBox.Par#}
	 */
	{
		__NAME: 'T.Form.CheckBox.Par',

		type: 'checkbox',
		placeholder: '',
		checked: false,
		onChange: D.doNothing,
		onClick: D.doNothing,
		small: false,
		disabled: false
	},
	T.Form.Base.Par
);
